import { useEffect } from "react";

const usePageHeightApplyForBanner = (
  isHeaderHidden: boolean,
  showMegaMenuSection?: string
) => {
  const reminderEl = document.getElementById(
    "subscription-expiration-reminder"
  );
  // Move header beneath the alert
  useEffect(() => {
    const navEl = document.querySelector("nav");
    const inboxContentEl = document.querySelector(".inbox-content");

    const megaMenu = document.getElementById("mega-menu");
    const megaMenuHeaderEl = document.querySelector(".header");
    const observer = new MutationObserver(() => updateHeaderStyle());
    const pageContentEl = document.querySelector(".page-content");
    const scrollToBottomComponent = document.querySelector(
      ".scroll-to-bottom-component"
    );
    const inboxSidebar = document.querySelector(".inbox-sidebar");
    const inboxToolbar = document.querySelector(".inbox-toolbar");
    const inboxMailsContainer = document.querySelector(
      ".inbox-mails-container"
    );

    const listItemsNotifications = document.querySelector(
      ".list-items-notifications"
    );

    // Create observer to track appearance of sideNotification
    const sideNotificationObserver = new MutationObserver((mutations) => {
      const currentListItemsNotifications = document.querySelector(
        ".list-items-notifications"
      );

      if (currentListItemsNotifications) {
        // Apply styles to listItemsNotifications
        if (reminderEl) {
          currentListItemsNotifications.setAttribute(
            "style",
            `max-height:calc(87vh - ${reminderEl?.clientHeight}px - 35px)`
          );
        } else {
          currentListItemsNotifications.setAttribute("style", "");
        }
      }
    });

    // Start tracking changes in body for sideNotification appearance
    sideNotificationObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });

    if (megaMenu) {
      megaMenu.style.top = isHeaderHidden ? "90px" : "160px";
    }

    if (pageContentEl) {
      if (isHeaderHidden) {
        pageContentEl.setAttribute("style", "");
        inboxContentEl?.setAttribute("style", "");
        inboxMailsContainer?.setAttribute("style", "");
        inboxSidebar?.setAttribute("style", "");
        listItemsNotifications?.setAttribute("style", "");

        if (window.innerWidth < 769) {
          scrollToBottomComponent?.setAttribute("style", "");
        }
      } else {
        if (reminderEl && megaMenuHeaderEl) {
          const fullNavHeight =
            reminderEl?.clientHeight + megaMenuHeaderEl?.clientHeight;
          inboxContentEl?.setAttribute(
            "style",
            `padding-top: ${fullNavHeight}px;`
          );
          pageContentEl.setAttribute(
            "style",
            `padding-top: ${fullNavHeight}px;`
          );
        }

        if (window.location.href.includes("home")) {
          pageContentEl.setAttribute("style", `padding-top: 120px;`);
        }
        if (window.location.href.includes("gallery")) {
          pageContentEl.setAttribute("style", `padding-top: 90px;`);
          if (window.innerWidth < 769) {
            pageContentEl.setAttribute(
              "style",
              `padding-top: ${reminderEl?.clientHeight}px;`
            );
            if (scrollToBottomComponent) {
              scrollToBottomComponent.setAttribute(
                "style",
                `top: calc(-${reminderEl?.clientHeight}px + 50vh) !important`
              );
            }
          }
        }
        if (reminderEl) {
          if (window.location.href.includes("inbox")) {
            reminderEl.setAttribute("style", "position: relative");
            if (inboxMailsContainer && inboxToolbar) {
              if (window.innerWidth > 768) {
                inboxMailsContainer.setAttribute(
                  "style",
                  `height: calc(100vh - ${
                    reminderEl?.clientHeight + inboxToolbar?.clientHeight
                  }px);  padding-bottom: calc(40px + ${
                    reminderEl?.clientHeight
                  }px);`
                );
              } else if (megaMenuHeaderEl && window.innerWidth < 769) {
                inboxMailsContainer.setAttribute(
                  "style",
                  `height:calc(100vh - ${
                    reminderEl?.clientHeight +
                    inboxToolbar?.clientHeight +
                    megaMenuHeaderEl?.clientHeight
                  }px)`
                );
              }
            }
            if (inboxSidebar) {
              if (window.innerWidth > 1199) {
                inboxSidebar?.setAttribute(
                  "style",
                  `height:calc(100vh - ${reminderEl?.clientHeight}px)`
                );
              }
            }
          } else {
            reminderEl.setAttribute("style", "");
          }
        }
      }
    }

    if (!megaMenuHeaderEl || !navEl) return;

    const updateHeaderStyle = () => {
      if (!isHeaderHidden) {
        if (
          navEl.classList.contains("show-white-header") ||
          showMegaMenuSection
        ) {
          megaMenuHeaderEl.setAttribute("style", "background: white");
        } else {
          megaMenuHeaderEl.setAttribute(
            "style",
            "background: linear-gradient(rgba(0, 0, 0, 0.6), transparent)"
          );
        }
      } else {
        megaMenuHeaderEl.setAttribute("style", "background: transparent");
      }
    };

    updateHeaderStyle();

    observer.observe(navEl, { attributes: true, attributeFilter: ["class"] });

    return () => {
      observer.disconnect();
      sideNotificationObserver.disconnect();
    };
  }, [isHeaderHidden, reminderEl, showMegaMenuSection]);

  // Separate useEffect for tracking sideNotification
  useEffect(() => {
    const reminderEl = document.getElementById(
      "subscription-expiration-reminder"
    );
    const sideNotification = document.querySelector(".side-notification");
    const listItemsNotifications = document.querySelector(
      ".list-items-notifications"
    );

    // Function to update styles
    const updateListItemsNotificationsStyle = () => {
      if (isHeaderHidden) {
        listItemsNotifications?.setAttribute("style", "");
        return;
      }

      if (sideNotification && listItemsNotifications && reminderEl) {
        listItemsNotifications.setAttribute(
          "style",
          `max-height:calc(87vh - ${reminderEl.clientHeight}px - 35px)` //35px - height of the notification header padding
        );
      }
    };

    // Call the function immediately
    updateListItemsNotificationsStyle();

    // Create observer to track DOM changes
    const observerListItemsNotifications = new MutationObserver(() => {
      updateListItemsNotificationsStyle();
    });

    // Start tracking changes in body
    observerListItemsNotifications.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Track window size changes
    const resizeObserver = new ResizeObserver(() => {
      updateListItemsNotificationsStyle();
    });

    if (reminderEl) {
      resizeObserver.observe(reminderEl);
    }

    return () => {
      observerListItemsNotifications.disconnect();
      resizeObserver.disconnect();
    };
  }, [isHeaderHidden]);

  useEffect(() => {
    const getElements = () => {
      const homeContainerEl = document.querySelector(
        ".home-container"
      ) as HTMLElement;
      const homeUploadContainerEl = document.querySelector(
        ".home-upload-container"
      );

      if (homeContainerEl) {
        if (!isHeaderHidden) {
          if (homeUploadContainerEl) {
            homeContainerEl.style.marginTop =
              window.innerWidth < 1200 ? "-35px" : "-60px";
          } else {
            homeContainerEl.style.marginTop = "";
          }
        } else {
          homeContainerEl.style.marginTop = "";
        }
      }
    };
    getElements();

    // Create observer to watch for DOM changes
    const homeContentObserver = new MutationObserver(() => {
      getElements();
    });

    // Observe the entire document body for changes
    homeContentObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => homeContentObserver.disconnect();
  }, [isHeaderHidden]);

  // Dedicated useEffect for header-drawer-container
  useEffect(() => {
    // Function to update header drawer container styles
    const updateHeaderDrawerContainerStyle = () => {
      const headerDrawerContainer = document.querySelector(
        ".header-drawer-container"
      );

      if (!headerDrawerContainer) return;

      if (isHeaderHidden) {
        headerDrawerContainer.setAttribute("style", "");
        return;
      }

      if (reminderEl) {
        if (headerDrawerContainer) {
          const maxHeight = `calc(100vh - ${reminderEl.clientHeight}px - 15px)`;
          const minHeight = `calc(102vh - ${reminderEl.clientHeight}px - 15px)`;
          const styleString = `max-height: ${maxHeight}; min-height: ${minHeight};`;

          headerDrawerContainer.setAttribute("style", styleString);
        }
      }
    };

    const updateInboxSidebarContainer = () => {
      const inboxSidebar = document.querySelector(".inbox-sidebar");

      if (!inboxSidebar) return;

      if (isHeaderHidden) {
        inboxSidebar.setAttribute("style", "");
        return;
      }

      if (reminderEl) {
        if (inboxSidebar && window.innerWidth < 1200) {
          inboxSidebar.setAttribute(
            "style",
            `padding-top: calc(100px + ${reminderEl.clientHeight}px) !important;
             height: calc(100vh + ${reminderEl.clientHeight}px);
             `
          );
        }
      }
    };

    // Apply styles immediately
    updateHeaderDrawerContainerStyle();
    updateInboxSidebarContainer();

    // Create observer to watch for DOM changes
    const headerDrawerObserver = new MutationObserver(() => {
      updateHeaderDrawerContainerStyle();
    });

    const inboxPanelObserver = new MutationObserver(() => {
      updateInboxSidebarContainer();
    });

    // Observe the entire document body for changes
    headerDrawerObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
    inboxPanelObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Set up a periodic check to ensure the styles are applied

    return () => {
      headerDrawerObserver.disconnect();
      inboxPanelObserver.disconnect();
    };
  }, [isHeaderHidden, reminderEl]);
};

export default usePageHeightApplyForBanner;
